/*
 * Main student chat workspace shell.
 *
 * This component owns the selected course/assignment context and passes it to
 * both the sidebar selectors and the active chat transcript/input panel.
 */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Sidebar from './SideBar';
import ChatContainer from './ChatContainer';
import NavBar from './Navbar';
import { useSessionContext } from '../context/SessionContext';

function ChatBotUI() {
  const [questionLog, setQuestionLog] = React.useState({});
  const [inputText, setInputText] = React.useState('');
  const [selectedCourseId, setSelectedCourseId] = useState('');
  const [selectedAssignmentId, setSelectedAssignmentId] = useState('');
  const [selectedAssignmentName, setSelectedAssignmentName] = useState('');
  const location = useLocation();
  const { selectedSessionId, setSelectedSessionId } = useSessionContext();

  useEffect(() => {
    document.body.classList.add('no-scroll-page');

    return () => {
      document.body.classList.remove('no-scroll-page');
    };
  }, []);

  useEffect(() => {
    const resumeState = location.state?.resumeChat;
    if (!resumeState) {
      return;
    }

    // History page navigation rehydrates the workspace without a full reload.
    setSelectedSessionId(resumeState.sessionId ?? null);
    setSelectedCourseId(resumeState.courseId ?? '');
    setSelectedAssignmentId(
      resumeState.assignmentId !== null && resumeState.assignmentId !== undefined
        ? String(resumeState.assignmentId)
        : ''
    );
    setSelectedAssignmentName(resumeState.assignmentName ?? '');
  }, [location.state, setSelectedSessionId]);

  return (
    <>
      <NavBar />
      <div className="chatbot-app" aria-label="Chat workspace">
      <Sidebar
        questionLog={questionLog}
        setQuestionLog={setQuestionLog}
        activeChat={selectedSessionId}
        setActiveChat={setSelectedSessionId}
        selectedCourseId={selectedCourseId}
        setSelectedCourseId={setSelectedCourseId}
        selectedAssignmentId={selectedAssignmentId}
        setSelectedAssignmentId={setSelectedAssignmentId}
        selectedAssignmentName={selectedAssignmentName}
        setSelectedAssignmentName={setSelectedAssignmentName}
      />
      <ChatContainer
        inputText={inputText}
        setInputText={setInputText}
        activeChat={selectedSessionId}
        setActiveChat={setSelectedSessionId}
        questionLog={questionLog}
        setQuestionLog={setQuestionLog}
        selectedCourseId={selectedCourseId}
        selectedAssignmentId={selectedAssignmentId}
        selectedAssignmentName={selectedAssignmentName}
      />
      </div>
    </>
  );
}

export default ChatBotUI;
